module.exports = __webpack_public_path__ + "static/media/bubble_art_1.834b5a2c.svg";